import { ScheduleDiffEl, ScheduleDiffTypes } from '@mopla/business-logic';

export const filterAndSortByUpdateState = (
	legsDiff: ScheduleDiffEl[] | null,
	...updateStates: ScheduleDiffTypes[]
): ScheduleDiffEl[] | undefined => {
	return legsDiff
		?.filter((leg) => updateStates.includes(leg.updateState))
		.sort(
			(a, b) =>
				new Date(a.start || 0).getTime() - new Date(b.start || 0).getTime()
		);
};
